// extracted by mini-css-extract-plugin
export default {"Buttons":"ReconnectButton_Buttons__39f9r","ReconnectButton":"ReconnectButton_ReconnectButton__UJBvm"};